export default "__VITE_ASSET__C61_L38m__"